import { createSlice } from "@reduxjs/toolkit";
import {
  createProjectThunk,
} from "./createProjectThunk";

const initialState = {
  NewProject: [],
  fetchProject: [],
  status: "idle" | "loading" | "succeeded" | "failed",
  error: null,
};

const ProjectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createProjectThunk.pending, (state, action) => {
      state.status = "loading";
      state.error = null;
    });
    builder.addCase(createProjectThunk.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.error.message || "Failed to Create Project";
    });
    builder.addCase(createProjectThunk.fulfilled, (state, action) => {
      state.status = "succeeded";
      console.log('create project', action.payload);
      state.NewProject = action.payload;
    });
  },
});
export default ProjectSlice.reducer;
